import {Facet} from "../components/Foundation/ObjectFilterSidebar";

/** The typed bounds, each carrying the control that declared the field.
 *
 *  THE CLIENT DOES NOT NAME A COLUMN. It sends the control -- the same word the facet service just
 *  handed it -- and the server is the only place that maps "Number" onto NUMERIC_VALUE. A bound
 *  for a field no longer in the payload is dropped rather than guessed at, which is what happens
 *  when a form stops offering a field as a filter while someone has it typed in.
 *
 *  An empty pair is kept in state (the reader is mid-edit) and skipped by the EC, so looking at a
 *  range control never narrows the list. */
export function withKinds(ranges: Record<string, {from: string; to: string}>, facets: Facet[]):
        Record<string, {kind: string; from: string; to: string}> {
    const control = new Map(facets.map(one => [one.Code, one.Control ?? "Number"]));
    const out: Record<string, {kind: string; from: string; to: string}> = {};
    for (const [fieldCode, range] of Object.entries(ranges ?? {})) {
        if (!control.has(fieldCode)) continue;
        out[fieldCode] = {kind: control.get(fieldCode)!, from: range?.from ?? "", to: range?.to ?? ""};
    }
    return out;
}
